module.exports = __webpack_public_path__ + "static/media/timelapse.ada549f7.jpg";